import type { ILead } from 'src/services/api/leads/types';
import { fetchLeadsIncludingArchived } from 'src/services/api/leads/use-leads';

type UpdateAssociatedLeads = (payload: {
    group_id: number;
    lead_uuids: string[];
}) => Promise<unknown>;

type SaveUpdatedCoapplicantGroupOptions = {
    groupId: number;
    selectedUuids: string[];
    visibleLeadUuids: string[];
    fetchAllLeads?: () => Promise<ILead[]>;
    updateAssociatedLeads: UpdateAssociatedLeads;
    addNotification: (message: string, type: 'error') => void;
};

export const saveUpdatedCoapplicantGroup = async ({
    groupId,
    selectedUuids,
    visibleLeadUuids,
    fetchAllLeads = fetchLeadsIncludingArchived,
    updateAssociatedLeads,
    addNotification,
}: SaveUpdatedCoapplicantGroupOptions): Promise<void> => {
    let allLeads: ILead[];
    try {
        allLeads = await fetchAllLeads();
    } catch {
        addNotification(
            'Failed to load all co-applicants. Please try again.',
            'error',
        );
        return;
    }

    const visibleUuids = new Set(visibleLeadUuids);
    const invisibleMemberUuids = allLeads
        .filter((candidate) => (
            candidate.coapplicant_leads_group_id === groupId &&
            !visibleUuids.has(candidate.uuid)
        ))
        .map((candidate) => candidate.uuid);

    await updateAssociatedLeads({
        group_id: groupId,
        lead_uuids: [...new Set([...selectedUuids, ...invisibleMemberUuids])],
    });
};
